import { Injectable } from '@angular/core';

import {ProductCollection} from "../../models/product-collection.model";

@Injectable()
export class CollectionService {
    constructor() {}

    createProductsCollection(fetchedData) {
        let productCollection = [];
        for (let fetchedCollection in fetchedData) {
            productCollection.push(new ProductCollection(fetchedCollection, fetchedData[fetchedCollection]));
        }

        return productCollection;
    }
}


// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/core/services/collection.service.ts